import { io } from "socket.io-client";
import URLS from "../services/URLS";

let socket = null;
const url = "https://tenee-api.suffescom.dev";

export const initializeSocket = (token, userId) => {


    if (!socket) {
        socket = io(url, {
            auth: { token },
            transports: ["websocket"],
            autoConnect: true,
            query: { userId },
        });
        socket.on("connect", () => {
            console.log("🟢 Socket connected:", socket.id);
            socket.emit("connecthotelAdminsocket", {
                userId,
                token,
            });
        });

        socket.on("disconnect", (reason) => {
            console.log("🔴 Socket disconnected:", reason);
        });
        socket.on("hotelAdminConnected", (data) => {
            console.log("✅ Hotel admin registered:", data);
        });
    }
    return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
};
